import Immutable from 'immutable';

import {
	webapi,
	createModuleState,
	REPORTED_EXCEPTION,
	showMessageBox,
} from 'ps-gui';
import { getPhrase } from '../../data/phrases';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('Activation');

export default class ActivationModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		return new ActivationModel(this.#data.set(name, value));
	}

	async setPassword() {
		const data = this.#data;
		if (data.get('pwd1') !== data.get('pwd2')) {
			return this.#setProperty('passwordVerificationError', getPhrase('passwordsDoNotMatch'));
		}
		const token = data.get('token');
		const idx = token.lastIndexOf(';');
		const authenticationCode = token.substring(0, idx);
		const authenticationCodeId = parseInt(token.substring(idx + 1));
		let res;
		try {
			res = await webapi.execute('/api/user/setPassword', {
				newPassword: data.get('pwd1'),
				authenticationCodeId,
				authenticationCode
			});
			if (res === REPORTED_EXCEPTION) {
				return this;
			}
		} catch (ex) {
			if (ex === 'invalidAuthenticationCode') {
				await showMessageBox(getPhrase('invalidActivationCode'));
				return this;
			} else if (ex === 'authenticationCodeExpired') {
				await showMessageBox(getPhrase('activationCodeExpired'));
				return this;
			}
		}

		return this.#setProperty('result', Immutable.fromJS(res)).#setProperty('passwordVerificationError', null);
	}

	setToken(value) {
		return this.#setProperty('token', value);
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}

	isResult() {
		return this.#data.get('result');
	}

	getResult() {
		return this.#data.get('result');
	}
}

